import {Stream} from 'xstream';
// import DB from '@/mock';

/**
 * 按指定格式注册vuex store的字段和操作函数。
 * 因为官方的ssr demo用了vuex，意味兼容csr和ssr的代码必需用上vuex。
 * 为了避免大量重复的模板代码（ajax请求部分，和mutation的set操作等），
 * 故封装这个工具函数。
 * 由于dispatch只能传一个参数，所以在dispatch的参数扩展两个保留字：
 * _setting: Stream.ajax的配置对象
 * _parseFn: 请求成功时调用，此时可以使用json做些副作用，如分页操作往
 * 页面记下页码。
 *
 * @param  {Object} module     store
 * @param  {String} name       在store的键，name应该是驼峰形式的。
 *                             同时会生成驼峰形式的`fetch${name}`的action和`set${name}`mutation。
 * @param  {String} api        请求的api
 * @param  {*}      defaultVal store[name]的默认值
 * @param  {String} sourcePath 通过ajax更新值的时候，值在json的路径，如: 'data.list'。
 *                             默认是data字段，如果希望取原值，传null。
 *                             有时候，可能需要先拿json做些副作用。可以在dispatch的时候传个_parseFn。
 * @param  {Object}      defaultVal ajax请求的默认参数
 * @return {Undefined}  无
 */
export function registerStoreItem(module, name, api, defaultVal, sourcePath, defaultParams, showErr) {
    if (!module.state) module.state = {}
    if (!module.actions) module.actions = {}
    if (!module.mutations) module.mutations = {}

    var mutationName = `set${upperFirstChat(name)}`;

    module.state[name] = defaultVal;
    module.actions[`fetch${upperFirstChat(name)}`] = dataActionFactory(api, mutationName, sourcePath, defaultParams, showErr);
    module.mutations[mutationName] = (state, list) => state[name] = list;
}

function _parseFn(json) { return json }

/**
 * 创建一个发起ajax的action，ajax成功后，commit数据给指定的mutation。
 * @param  {String}          url             请求地址
 * @param  {String|Function} type            mutation的名字，为函数时，不自动commit。
 * @param  {String|Null}     exp             数据在json路径，为null是commit json。
 * @param  {Object}          [defaultParams] 请求的默认参数。
 * @return {Promise} 返回一个promise
 */
export function dataActionFactory(url, type, exp, defaultParams, showErr = true) {
    var argLen = arguments.length;

    return function({commit}, params) {
        var parse = parseExp(params, '_parseFn') || _parseFn;
        var setting = params._setting;

        // _parseFn和_setting作为保留字，不参与作为请求参数
        params = omit(params, ['_parseFn', '_setting']);

        // return Stream.of(DB[url]).delay(100)
        return Stream.ajax(url, Object.assign({}, defaultParams, params), setting, false)
            .catch(err => {
                if(!!showErr) {
                    let errMsg = '';
                    if(typeof(showErr) === 'string') {
                        errMsg = showErr
                    } else {
                        errMsg = '数据加载失败' || err.msg || err
                    }
                    Stream.ajax.defaultSetting.toastAPI(errMsg)
                }
            })
            .toPromise()
            .then(function(json) {
                var data = (argLen < 3 && !exp || exp === null) ? json : parseExp(json, exp || 'data');
                data = parse(data);

                if (typeof type === 'function') {
                    return type(data, commit);
                } else {
                    commit(type, data);
                    return json;
                }
            }/*, err => Promise.reject(err) */);
    }
}

/**
 * 设置/计算上下文值
 * @param  {}       context 上下文对象。
 * @param  {String} exp     字段表达式，以'.'和'[\d+]'分割成字段的访问堆栈
 * @param  {}       val     要设置的值，不传时为get。
 *
 * @example
 *  var data = {
 *      asd: {qwe: 123}
 *  };
 *
 *  parseExp(data, 'asd.qwe', 789);
 */
export function parseExp(context, exp, val) {
    var chain = exp.replace(/^\[(\d+)\]/, '$1').replace(/\[(\d+)\]/g, '.$1').split('.'),
        last_key;

    if (arguments.length === 3) {
        last_key = chain.pop();
    }

    for (var i = 0; i < chain.length; i++) {
        if (!context) return;
        context = context[chain[i]];
    }

    if (last_key) {
        context[last_key] = val;
    } else {
        return context;
    }
}

export function parseUrl(url) {
    var urlData = {},
        parmas, match, i,
        urlReg = /[?&]([^=]*?)(?:=([^&]*?))?(?:(?=&)|(?=$))/g,
        urlParamsReg = /[?&]([^=]*?)(?:=([^&]*?))?(?:(?=&)|(?=$))/;

    match = (url || location.href).match(urlReg);

    if (match) {
        for (i = match.length - 1; i >= 0; i--) {
            parmas = match[i].match(urlParamsReg);

            if (parmas[1]) {
                // parmas[2]为undefined时，设为空字符串
                urlData[parmas[1]] = typeof parmas[2] !== 'undefined' ? parmas[2] : parmas[2] || '';
            }
        }
    }

    return urlData;
}

export function upperFirstChat(name) {
    return name[0].toUpperCase() + name.slice(1);
}

// lodash.pick的代替品
export function pick(obj, keys) {
    return keys.reduce(function (result, key) {
        result[key] = obj[key];
        return result;
    }, {});
}

// lodash.omit的代替品
export function omit(obj, keys) {
    var result = {}, key;

    for (key in obj) {
        if (keys.indexOf(key) == -1) result[key] = obj[key]
    }

    return result;
}

export function getUrlEnv() {

}

// 获取URL 中 Query
export function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};


export function loadScript(url) {
    return new Promise((resolve, reject)=>{
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.onload = function() {
            resolve('success');
            script.onload = null;
        };
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    })
};


export function getUrlSearchParamsObj(url){
    let urlObj = new URL(url);
    let params = stringToObj(urlObj.search.replace('?', ''));
    console.log(params);
    return params;

}

export function stringToObj(str){
    if (typeof str === 'string') {
        if (str === '') {
            return {};
        }
        let params = {};
        str.split('&').map(item => params[item.split('=')[0]] = item.split('=')[1]);
        return params;
    } else {
        return {};
    }
}

export function objToUrlParams(obj) {
    let paramsStr = '';
    for(let key in obj) {
        if((typeof obj[key]).toLowerCase() !== 'object') {
            // 除去undefined
            if(obj[key]!== undefined) {
                paramsStr = paramsStr + `${key}=${obj[key]}&`;
            }
        } else if(obj[key] instanceof Array) {
            paramsStr = paramsStr + `${key}=${obj[key].join()}&`;
        } else {
            let temp = objToUrlParams(obj[key]);
            paramsStr = paramsStr + temp;
        }
    }
    // 移除最后的那个 & 符号
    return paramsStr.slice(0, paramsStr.length - 1);
}


/**
 *
 * @param params 要加密的参数
 * @param $apiSecret 签名密钥
 */
import md5 from 'md5';

export function getRequestSign(params = {}, apiSecret = '6767790dfc5c34d32e250ea3e9104910') {
    let arr = [];
    let timestamp = params["timestamp"];
    if (params["timestamp"]) {
        params = omit(params, "timestamp");
    }

    //字典按key的字母顺序
    let keys = Object.keys(params).sort();
    let paramsStr = '';

    //所有参数名和参数值按顺序拼接一起
    keys.map(key => {
        paramsStr = `${paramsStr}${key}=${params[key]},`
    })

    //拼接apiSecret
    paramsStr = `${paramsStr}${timestamp}${apiSecret}`;
    //md5加密
    let sign = md5(paramsStr); // 小写
    return sign;
}


/**
 *
 * @param dateObj 日期对象 Date Object
 * @param fmt 格式，字符串类型，YY代表年，MM代表月，DD代表日，hh时，mm分，ss秒，SS毫秒
 * @returns {*}
 */
export function dateFormater(dateObj, fmt) {
    if(dateObj instanceof Date) {

    } else if (!(dateObj instanceof Date) && typeof(dateObj) == 'string') {
        dateObj = new Date(dateObj.replace(/-/g, '/'));
    } else {
        console.error('日期数据格式错误');
        return;
    }
    console.log(dateObj);
    var o = {
        "M+": dateObj.getMonth() + 1, //月份
        "D+": dateObj.getDate(), //日
        "h+": dateObj.getHours(), //小时
        "m+": dateObj.getMinutes(), //分
        "s+": dateObj.getSeconds(), //秒
        "q+": Math.floor((dateObj.getMonth() + 3) / 3), //季度
        "S": dateObj.getMilliseconds() //毫秒
    };
    if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (dateObj.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/*
    将HTML代码中的文字提取出来
 */
export function transHtmlToText(htmlCode){
    let temp = document.createElement('div');
    temp.innerHTML = htmlCode;
    return temp.innerText;
}


export function urlCategoryMap(data){
    let urlMap = {
      '情感': 'qinggan',
      '性格': 'xingge',
      '健康': 'jiankang',
      '职场': 'zhichang',
      '人际': 'renji',
      '能力': 'nengli',
      '亲子': 'qinzi'
    }
    return urlMap[data] || 'jingxuan'
}   


// WEBPACK FOOTER //
// ./src/lib/util.js